




import { Close as CloseIcon, Delete as DeleteIcon, Person } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import '../../App.css';
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";

const MyCampaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaignsPerPage, setCampaignsPerPage] = useState(6);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  useEffect(() => {
    const fetchCampaigns = async () => {
      const influencerId = localStorage.getItem("influencerID");
      if (!influencerId) {
        toast.error("Influencer ID not found!");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `https://server-side-influencer.onrender.com/influencer/${influencerId}/campaigns`
        );
        if (Array.isArray(response.data.campaigns)) {
          setCampaigns(response.data.campaigns);
        } else {
          toast.error("Invalid campaign data format.");
        }
      } catch (error) {
        console.error("Error fetching campaigns:", error);
        toast.error("Failed to load campaigns.");
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();

    const handleResize = () => {
      setCampaignsPerPage(window.innerWidth >= 1024 ? 6 : 3);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDelete = async (campaignId) => {
    const influencerId = localStorage.getItem("influencerID");
    if (!influencerId) {
      toast.error("Influencer ID not found!");
      return;
    }

    try {
      await axios.delete(
        `https://server-side-influencer.onrender.com/influencer/${influencerId}/${campaignId}`
      );
      setCampaigns((prev) => prev.filter((c) => c.campaignId !== campaignId));
      toast.success("Campaign removed.");
    } catch (error) {
      console.error("Error deleting campaign:", error);
      toast.error("Failed to delete campaign.");
    }
  };

  const indexOfLastCampaign = currentPage * campaignsPerPage;
  const indexOfFirstCampaign = indexOfLastCampaign - campaignsPerPage;
  const currentCampaigns = campaigns.slice(indexOfFirstCampaign, indexOfLastCampaign);
  const totalPages = Math.ceil(campaigns.length / campaignsPerPage);

  const Modal = ({ campaign, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 hide-scrollbar">
      <div className="bg-white rounded-2xl w-full max-w-xl p-6 relative">
        <button className="absolute top-4 right-4 text-gray-500 hover:text-red-600" onClick={onClose}>
          <CloseIcon />
        </button>
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">{campaign.campaignName}</h2>
        <div className="space-y-3 text-gray-700">
          <p><strong>Type:</strong> {campaign.campaignType}</p>
          <p><strong>Start:</strong> {new Date(campaign.startDate).toDateString()}</p>
          <p><strong>End:</strong> {new Date(campaign.endDate).toDateString()}</p>
          <p><strong>Budget:</strong> ₹{campaign.budget}</p>
          <p><strong>Followers:</strong> {campaign.followerRange[0]}–{campaign.followerRange[1]}</p>
          <p><strong>Tags:</strong> {campaign.tags.join(', ')}</p>
          <p><strong>Task:</strong> {campaign.task}</p>
          <p><strong>Description:</strong> {campaign.description}</p>
        </div>
      </div>
    </div>
  );
// sssss
  return (
    <div className="flex flex-col h-screen">
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="My Campaigns" />
      </div>

      <div className="flex flex-1 overflow-y-auto pt-20">
        <div className="fixed top-0 left-0 bottom-0 z-50 text-white">
          <Navbar />
        </div>

        <div className="flex-1 ml-8 p-6 mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 ml-8 mt-5">
            {loading
              ? Array.from({ length: campaignsPerPage }).map((_, i) => (
                  <div key={i} className="h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden">
                    <Skeleton height="50%" />
                    <div className="p-4">
                      <Skeleton height={20} width="80%" />
                      <Skeleton height={20} width="60%" className="mt-2" />
                      <Skeleton height={20} width="40%" className="mt-2" />
                    </div>
                  </div>
                ))
              : campaigns.length === 0 ? (
                  <div className="col-span-full text-center text-gray-600 text-lg font-semibold mt-10">
                    No campaign applied yet
                  </div>
                ) : (
                  currentCampaigns.map((campaign) => (
                    <div
                      key={campaign.campaignId}
                      onClick={() => setSelectedCampaign(campaign)}
                      className="relative w-full h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 cursor-pointer"
                    >
                      <div
                        className="h-1/2 relative"
                        style={{
                          height: '190px',
                          backgroundImage: `url(${campaign.campaignImages[0]})`,
                          backgroundSize: '100% 100%',
                          backgroundRepeat: 'no-repeat',
                        }}
                      >
                        <div className="absolute inset-0 bg-black/30" />
                        <div
                          className="absolute top-2 right-2 text-white bg-black/40 hover:bg-red-600 p-1 rounded-full cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(campaign.campaignId);
                          }}
                        >
                          <DeleteIcon />
                        </div>
                        <div className="absolute top-2 left-2 w-14 h-14 bg-white rounded-full overflow-hidden border-2 border-white shadow">
                          <img src={campaign.logo} alt="Brand Logo" className="w-full h-full object-cover" />
                        </div>
                      </div>

                      <div className="h-1/2 pt-10 px-4 pb-4 flex flex-col justify-between">
                        <h2 className="text-lg font-bold text-gray-800 text-center">{campaign.campaignName}</h2>
                        <div className="flex justify-end items-center text-sm text-gray-600 mt-2">
                          <Person fontSize="small" className="mr-1" />
                          {campaign.followerRange[0]} – {campaign.followerRange[1]}
                        </div>
                      </div>
                    </div>
                  ))
                )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-4 mt-8">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                className="px-4 py-2 bg-gray-200 text-black rounded-lg disabled:opacity-50"
              >
                Prev
              </button>
              <span className="text-sm font-medium">
                Page {currentPage} of {totalPages}
              </span>
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                className="px-4 py-2 bg-gray-200 text-black rounded-lg disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {selectedCampaign && (
        <Modal campaign={selectedCampaign} onClose={() => setSelectedCampaign(null)} />
      )}
    </div>
  );
};

export default MyCampaigns;

